var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228 399.3",
    style: {
      enableBackground: "new 0 0 228 399.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.9,145.9c-13.6-13.4-30-23-47.9-28.2c18.6-11,31.2-31.3,31.2-54.4c0-34.9-28.4-63.3-63.3-63.3 C79,0,50.6,28.4,50.6,63.3c0,23.4,12.8,43.8,31.7,54.7C35,132.3,0,177.6,0,230.6v34.6c0,18.6,15.1,33.7,33.7,33.7h17v66.7 c0,18.6,15.1,33.7,33.7,33.7h59.2c18.6,0,33.7-15.1,33.7-33.7v-66.7h17.2c18.6,0,33.7-15.1,33.7-33.7v-38 C228,196.4,215.9,167.5,193.9,145.9z M113.9,25.3c21,0,38,17,38,38c0,21-17,38-38,38s-38-17-38-38C75.9,42.3,92.9,25.3,113.9,25.3z  M202.7,265.2c0,4.6-3.8,8.4-8.4,8.4h-29.8c-7,0-12.6,5.7-12.6,12.6v79.4c0,4.6-3.8,8.4-8.4,8.4H84.3c-4.6,0-8.4-3.8-8.4-8.4v-79.4 c0-7-5.7-12.6-12.6-12.6H33.7c-4.6,0-8.4-3.8-8.4-8.4v-34.6c0-49.9,39.1-91.2,87.1-92.1c24-0.3,46.7,8.6,63.8,25.4 s26.6,39.3,26.6,63.3V265.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.46dc977a.svg";
export { ForwardRef as ReactComponent };